import type { Release } from '../releases';

export default {
  id: '2026-11-03-site-timesheet-totals',
  at: '2026-11-03T17:36:00Z',
  title: 'Часы принятых отчётов складываются в табеле',
  modules: ['site', 'resources'],
  items: [
    'Если один работник сдал по одной работе два принятых отчёта на 8 и 4 часа, табель показывает 12. Повторная отправка той же команды не увеличивает часы.',
    'После действия «Открыть снова» в табеле остаются часы действующих принятых отчётов. Повторное принятие исправленного отчёта учитывает его новую версию один раз.',
    'Ручные правки сохраняют прежний порядок работы. Статус проведения проверяет фактические часы и текущую принятую версию отчёта.',
  ],
  why: 'Последний отчёт заменял часы предыдущего, поэтому часть принятых трудозатрат терялась в табеле. Теперь часы разных принятых отчётов учитываются вместе.',
  link: '/site/review',
} satisfies Release;
